import { FormRow, FormRowSelect } from '.'
import { useAppContext } from '../context/appContext';
import Wrapper from '../assets/wrappers/SearchContainer';

const SearchContainer = () => {
    const {
        isLoading,
        search,
        sort,
        sortOptions,
        handleChange,
        clearFilters,
    } = useAppContext();

    const handleSearch = (e) => {
        if (isLoading) return;
        handleChange({ name: e.target.name, value: e.target.value });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        clearFilters();
    }

    return (
        <Wrapper>
            <form className='form'>
                <h4>Filter</h4>
                <div className='form-center'>
                    <FormRow
                        type='text'
                        labelText="Kommentar Suche"
                        name="search"
                        value={search}
                        handleChange={handleSearch}
                    />
                    <FormRowSelect
                        name='sort'
                        labelText='Sortierung'
                        value={sort}
                        handleChange={handleSearch}
                        list={sortOptions} />
                    <button
                        className='btn btn-block btn-danger'
                        disabled={isLoading}
                        onClick={handleSubmit}>
                        Zurücksetzen
                    </button>
                </div>
            </form>
        </Wrapper>
    )
}

export default SearchContainer;